export default __webpack_public_path__ + "static/5-1ce4514e3e0c8f5baf1f92cab68efbd2.jpg";